
const formatUserName = (user) => (`${user?.firstName || ""} ${user?.lastName || ""}`.trim() || "-");

export default formatUserName;
